import { brandItems } from './brand';
import type { CategoryItem } from './category';

export interface BrandCategory {
  id: string;
  title: string;
  brands: CategoryItem[];
}

const findBrandsByNames = (brandNames: string[]): CategoryItem[] => {
  return brandNames
    .map((name) => {
      const brand = brandItems.find((item) => item.name.toLowerCase() === name.toLowerCase());
      return brand;
    })
    .filter((brand): brand is CategoryItem => brand !== undefined);
};

interface CategoryDefinition {
  type: string;
  brandNames: string[];
}

const categoryDefinitions: CategoryDefinition[] = [
  {
    type: 'Hydration and Moisturizing',
    brandNames: ['LANEIGE', 'ILLIYOON', 'INNISFREE', 'IOPE', 'Isntree', 'Pyunkang Yul'],
  },
  {
    type: 'Acne Treatment and Sensitive Skin',
    brandNames: ['Anua', 'COSRX', 'Dr. Jart+', 'ROUND LAB', 'SOME BY MI', 'SIDMOOL'],
  },
  {
    type: 'Anti-Aging and Brightening',
    brandNames: ['AHC', 'Beauty of Joseon', 'KAHI', 'MISSHA', 'Sulwhasoo', 'Dr.G'],
  },
  {
    type: 'Exfoliation and Masks',
    brandNames: ['TONYMOLY', 'MAY COOP', 'MEDIHEAL', 'SKINFOOD', 'SKIN1004', 'Torriden'],
  },
  {
    type: 'Multi-Functional Skincare',
    brandNames: ['Haruharu WONDER', 'Holika Holika', 'AESTURA', 'AMPLE:N', 'ETUDE', 'nooni'],
  },
];

const generateBrandCategories = (): BrandCategory[] => {
  return categoryDefinitions.map((def, index) => ({
    id: (index + 1).toString(),
    title: `Best in ${def.type}`,
    brands: findBrandsByNames(def.brandNames),
  }));
};

export const BRAND_CATEGORIES: BrandCategory[] = generateBrandCategories();

export default BRAND_CATEGORIES;
